import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import { multiSitePages } from '.';

import HamburgerMenu from './HamburgerMenu';

const MainNavigation = () => {
  return (
    [<nav className="main-navigation">
     
      <div className="nav-container">
        {multiSitePages.filter((item) => !item.hideFromNav).map((item, index) => {
          return (
            <div key={index} className="nav-item">
              <Link to={item.path}>{item.label}</Link>
            </div>
          )
        })}
      </div>
    </nav>,  <HamburgerMenu></HamburgerMenu>]
  );
};

export default MainNavigation;


